<template>
	<div class="o-container o-container--thin registration-activation-page">
		<verify-email-form
			v-if="form === 'verify'"
			:submit="verify"
			:sendAgain="toggleForms"
			:email="email"
			:code="code"
		/>

		<resend-verification-code-form
			v-else-if="form === 'resend'"
			:submit="resend"
			:cancel="toggleForms"
			:email="email"
		/>
	</div>
</template>

<script>
	import VerifyEmailForm from '../forms/VerifyEmailForm.vue';
	import ResendVerificationCodeForm from '../forms/ResendVerificationCodeForm.vue';
    import '../../store/modules/session/session';
	import { buildAuthorizeUrl } from '../../api/oauthClient';

	export default {
		components: {
			VerifyEmailForm,
			ResendVerificationCodeForm
		},
		data() {
			return {
				form: 'verify',
				email: this.$session.has('register_email') ? this.$session.get('register_email') : '',
				code: this.$session.has('register_code') ? this.$session.get('register_code') : ''
			};
		},
		created() {
			this.form = this.$route.name;
		},
		methods: {
			toggleForms() {
				let toForm = this.$route.name === 'verify' ? 'resend' : 'verify';
				this.form = toForm;
				this.$router.push({
					name: toForm,
					params: {
						form: toForm
					}
				});
			},
			verify(data) {
			    this.$session.set('register_email', data.email.toLowerCase());
                console.time("TIME_calling_user.VERIFY");
			    return this.$store.dispatch('user/VERIFY', data).then(async () => {
                    console.timeEnd("TIME_calling_user.VERIFY");
					if (window.OAuthConfig && window.OAuthConfig.enabled) {
						// OAuth flow: send user to the login UI for a fresh session.
						// login_hint pre-fills the email so the user does not need to retype it.
						// state ensures OAuthCallbackPage redirects to /my-account/preferences
						// so new users land on the onboarding page after login.
						const url = await buildAuthorizeUrl({ prompt: 'login', loginHint: data.email.toLowerCase(), state: '/my-account/preferences' });
						window.location.href = url;
					} else {
						// Legacy SDK flow: redirect to the login page.
						this.$router.push({
							name: 'login',
							params: {
								form: 'simplified'
							}
						});
					}
				});
			},
			resend(data) {
                this.$session.set('register_email', data.email.toLowerCase());
                return this.$store.dispatch('user/RESEND_CODE', data).then(() => {
                    // redirect to the verification page
					if (this.$session.has('register_email')) {
						this.form = 'verify'
                    } else {
                        this.$router.push({
                            name: 'verify'
                        });
                    }
				});
			}
		}
	}
</script>
